/**
 * Toggle classes
 * @module switchClass
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'switchClass';
export const DEFAULTS = {
  switchClass: '',
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
  let opts = $.extend({}, DEFAULTS, $el.data(), options);
  return opts;
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  $el.on('click', evt => {
    evt.preventDefault();
    const hasHref = $el.attr('href') !== undefined;
    const $hrefTarget = $($el.attr('href'));
    const $dataTarget = $(options.targetElement);
    const $changingElClass = hasHref ? $hrefTarget : $dataTarget;
    $changingElClass.toggleClass(options.switchClass);
  })
}
/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function switchClass(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, switchClass);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/switch-class.js